import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b5f709d0&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5f709d0')) {
      api.createRecord('b5f709d0', component.options)
    } else {
      api.reload('b5f709d0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b5f709d0&", function () {
      api.rerender('b5f709d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/editPassword/index.vue"
export default component.exports